import React from 'react';
import css from '../css/MyTable.module.css'
import {Table} from "react-bootstrap";

const MyTable = ({children, Header, Footer, hover = true, alignMiddle = false, ...props}) => {
    return (
        <div className={css.wrapper}>
            {Header && <div className={css.header}><Header/></div>}
            <div className={css.tableWrapper}>
                <Table className={`${css.table} ${alignMiddle ? css.alignContentMiddle : ''}`} hover={hover} {...props}>{children}</Table>
            </div>
            {Footer && <div className={css.footer}><Footer/></div>}
        </div>
    );
};

export default MyTable;